import React, { useEffect } from 'react';
import {
    Grid,
    Card,
    InputLabel,
    Button,
    Typography,
} from '@mui/material';
import SoftInput from 'components/SoftInput';
import SoftBox from 'components/SoftBox';
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout';
import DashboardNavbar from 'examples/Navbars/DashboardNavbar';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useNavigate, useParams } from 'react-router-dom';
import service from '../../api/services';
import toast from 'react-hot-toast';
import SoftTypography from 'components/SoftTypography';
import SoftButton from 'components/SoftButton';

const validationSchema = Yup.object({
    oldEmail: Yup.string().email('Invalid email').required('Old email is required'),
    oldBusinessName: Yup.string(),
    newEmail: Yup.string().email('Invalid email'),
    newBusinessName: Yup.string(),
});

const ChangeEmailForm = () => {
    const params = useParams()
    const navigate = useNavigate()
    const formik = useFormik({
        initialValues: {
            oldEmail: '',
            oldBusinessName: '',
            newEmail: '',
            newBusinessName: '',
        },
        validationSchema,
        onSubmit: async (values) => {
            try {
                const payload = {
                    oldEmail: values.oldEmail,
                    oldBusinessName: values.oldBusinessName,
                    email: values.newEmail,
                    firstName: values.newBusinessName,
                };
        
                const response = await service.users.edit(params?.id,payload);
        
                if (response.status === 200 || response.status === 201) {
                    toast.success(response.message || 'Updated Successfully');
                    navigate(-1);
                } else {
                    toast.error(response.message || "Something went wrong.");
                }
            } catch (error) {
                toast.error(error?.response?.data?.message || "Server error");
                console.error('Submission error:', error);
            }
        }
        
    });
    const getDetailById = async () => {
        try {
          const res = await service.users.getDetailById(params.id);
          const data = res?.data?.data;
          formik.setValues({
            oldEmail: data?.email || '',
            oldBusinessName: data?.firstName || '',
            // newEmail: data?.newEmail || '',
            // newBusinessName: data?.newBusinessName || '',
          });
      
        } catch (error) {
          console.error('Error fetching user details:', error);
        }
      };
      
      useEffect(() => {
        if (params?.id) {
          getDetailById();
        }
      }, []);
      
    return (
        <DashboardLayout>
            <DashboardNavbar />
            <SoftBox mt={3}>
                <Card  className="glassmorphism-card" sx={{ padding: 3, boxShadow: 2 }}>
                    <SoftTypography variant="h6" fontWeight="bold" mb={2}>
                        Change Email Address
                    </SoftTypography>

                    <form onSubmit={formik.handleSubmit}>
                        <Grid container spacing={3}>
                            {/* Left Column */}
                            <Grid item xs={12} md={6}>
                                <SoftTypography variant="caption" fontWeight="bold" required>Old Email</SoftTypography>
                                <SoftInput
                                    name="oldEmail"
                                    placeholder="Enter old email"
                                    value={formik.values.oldEmail}
                                    onChange={formik.handleChange}
                                    error={formik.touched.oldEmail && Boolean(formik.errors.oldEmail)}
                                    onBlur={formik.handleBlur}
                                    disabled
                                />
                                {formik.touched.oldEmail && formik.errors.oldEmail && (
                                    <Typography variant="caption" color="error">
                                        {formik.errors.oldEmail}
                                    </Typography>
                                )}

                                <SoftBox mt={2}>
                                    <SoftTypography variant="caption" fontWeight="bold">Old Business Name</SoftTypography>
                                    <SoftInput
                                        name="oldBusinessName"
                                        placeholder="Enter old business name"
                                        value={formik.values.oldBusinessName}
                                        onChange={formik.handleChange}
                                        disabled
                                    />
                                </SoftBox>
                            </Grid>

                            {/* Right Column */}
                            <Grid item xs={12} md={6}>
                                <SoftTypography variant="caption" fontWeight="bold">Enter New Business Email</SoftTypography>
                                <SoftInput
                                    name="newEmail"
                                    placeholder="Enter Email"
                                    value={formik.values.newEmail}
                                    onChange={formik.handleChange}
                                />

                                <SoftBox mt={2}>
                                    <SoftTypography variant="caption" fontWeight="bold">Enter New Business Name</SoftTypography>
                                    <SoftInput
                                        name="newBusinessName"
                                        placeholder="Enter Business Name"
                                        value={formik.values.newBusinessName}
                                        onChange={formik.handleChange}
                                    />
                                </SoftBox>
                            </Grid>

                            {/* Buttons */}
                            <Grid item xs={12} mt={1}>
                                <SoftBox display="flex" gap={2}>
                                    <SoftButton type="submit" variant="gradient" color="info">
                                        Submit
                                    </SoftButton>
                                    {/* <Button variant="outlined">Cancel</Button> */}
                                    <SoftButton

                                    variant="outlined"
                                    color="info"
                                    onClick={() => navigate(-1)}
                                >
                                    Cancel
                                </SoftButton>
                                </SoftBox>
                            </Grid>
                        </Grid>
                    </form>
                </Card>
            </SoftBox>
        </DashboardLayout>
    );
};

export default ChangeEmailForm;
